import { render } from "./SymbolsBase.vue?vue&type=template&id=ca88042e"
import script from "./SymbolsBase.vue?vue&type=script&lang=js"
export * from "./SymbolsBase.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./SymbolsBase.vue?vue&type=style&index=0&id=ca88042e&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script